var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMixedMercantile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5123_18499",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5123_18499",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACrElEQVR4nO2bMW7UQBSGp0DAAVAQEhUXyAXo4QJcAEoU6KHYNpRbMP5/b7ES5UpwAQ6QRUpBSwcFUKOlQ5HRhEUhK+9ir8Yzb5z/k14Tjaz3vrx5nji2c0IIIYQQogOLxeI6gFckvwH4SvI4/CzWerEmiCLZbMSxi7RerAmd2SLuu4u0vjgWf7bsUwAnAH5uFLoi+Zbk49lsdrvPdVuknUes9UVB8g6A021FbsQZySXJl1VVHXa4tkT/08mnHSW3xRcArwE8nM/nNyV6C2FccH/JlyKMHADvqqp68nfEqKMvtvYyluiWEfNBoi9ErwYSvTNizfRi+F9h0+n0Rl3XD9Zz+HNE2eenGO/9QZ98iqVvYVVVHQJ4sR45Z5FGzDJcM1xbolsgeYvkIwBvSP7IMWqKIVZhk8nkGsn74c9lAJ8keiDRm3jv75F8DuA9yV/q6ARblRFGjCud1IVN9hwxrnRyF+Y7jhhXOpYK894fWMonKtYKo7F8RlsYjeUz2sJoLJ9shTHT+m2x/m9QeBzwLDyXcVYpXTQvx8e6ru86i4xMdBNkm+zsEYpuABw5a4xU9ImzxhhFk1w5a/QVMTRD/yKzYS1RSnQaJDoREp0IiU6ERJd1vCv/1EGJlmim7Oi+34Coo9N9M9JodKT5ZqSR6P1El3EXLv14J9GU6C6ooxMh0YmQ6EQULzpWoOd7FKN91jG0aPZ8j0KiI8qe7uhsiY47To4kOsEIwY73KNTRcWWvJHrPu7yLtL4v1vLJliglWqKpju6OtR2WLVFqdEg0LXT00OEi7YCh84mGRFOiqY6mRodGBzWjqZuhztEu16kj1/q+WMsnW6KUaImmOro71nZYtkSp0bFbxFULNzS5C6SRkGhKdJO7C9XRzC9Oo4NXdEYLIYQQQgghhEvEbzQaq7RhKgT/AAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixedMercantile);
export default __webpack_public_path__ + "static/media/mixed-mercantile.c8e932543ebf9b1640d8f0ad08770012.svg";
export { ForwardRef as ReactComponent };